import { DatePipe } from '@angular/common'
import { Component, Input, OnInit } from '@angular/core'
import { MatSnackBar } from '@angular/material/snack-bar'
import { Router } from '@angular/router'
import { EvidaEvents } from 'src/app/tracking/evida-events'
import { EvidaScreens } from 'src/app/tracking/evida-screens'
import { SimpleAnalytics, TrackEvent } from 'src/app/tracking/simple-analytics'
import { Logger } from 'src/app/utils/logger'
import { RedirectTo } from 'src/app/utils/redirect-to'
import { Utils, CORRELATION_ID_HEADER_NAME, DATE_HEADER_NAME } from 'src/app/utils/utils'
import { environment } from 'src/environments/environment'
import { ReponseErrors } from '../../../soft-login/models/error.model'
import { LoadingStateService } from '../../services/loading-state.service'
import { ErrorDate } from '../evida-error/error-date.model'

@Component({
    selector: 'app-site-error',
    templateUrl: './site-error-component.html',
    styleUrls: ['./site-error-component.scss'],
    standalone: false,
})
export class SiteErrorComponent implements OnInit {
    @Input() public errorCode?: string
    @Input() public errorInfo?: string
    @Input() public correlationId?: string
    @Input() public url?: string // The URL where the error occured
    @Input() public date?: string
    public readonly evidaLoginLink = environment.links.login
    public reponseErrors = ReponseErrors
    public showLogout: boolean = true
    public errorObject: any

    constructor(
        private router: Router,
        private logger: Logger,
        private loading: LoadingStateService,
        private snack: MatSnackBar,
        private datePipe: DatePipe
    ) {}

    ngOnInit(): void {
        this.trackErrorUnexpected()
        let state = this.router.currentNavigation()?.extras?.state
        if (!state) {
            state = this.router.lastSuccessfulNavigation()?.extras?.state
        }

        this.logger.error(`Error occured. Navigation state: ${JSON.stringify(state, null, 2)}`)
        if (state) {
            this.errorCode = this.errorCode ? this.errorCode : state.errorCode
            this.errorInfo = this.errorInfo ? this.errorInfo : state.errorInfo
            this.correlationId = this.correlationId ? this.correlationId : state.correlationId
            this.date = this.date ?? state.date
            this.url = this.url ? this.url : state.url
        }

        if (this.errorCode === ReponseErrors.PRIVATE_LOGIN_ON_BUSINESS_ERROR) {
            this.showLogout = false
        }

        // Create a mock error object for evida-error component to consume
        if (this.correlationId || this.date) {
            this.errorObject = this.createMockErrorObject(this.correlationId, this.date)
        }

        this.loading.setNotLoading()
    }

    @TrackEvent(EvidaEvents.SiteError.clicks.backToHomepage)
    public backToHomepage() {
        RedirectTo.loginLandingPage()
    }

    public previousPage() {
        window.history.back()
    }

    public retry() {
        if (this.url) {
            document.location.href = this.url
        }
    }

    public onCopyCorrelationId() {
        if (this.correlationId) {
            Utils.copyToClipboard(this.correlationId)
            this.snack.open('Kopieret til udklipsholderen!', /*action*/ undefined, {
                duration: 1200,
            })
        }
    }

    public get errorDate(): ErrorDate | null {
        if (!this.date) {
            return null
        }
        return {
            date: this.date,
        }
    }

    private createMockErrorObject(correlationId?: string, date?: string): any {
        const headers = new Map<string, string>()
        if (correlationId) {
            headers.set(CORRELATION_ID_HEADER_NAME, correlationId)
        }
        if (date) {
            headers.set(DATE_HEADER_NAME, date)
        }
        return {
            headers: {
                get: (key: string) => headers.get(key) || null,
            },
        }
    }

    private trackErrorUnexpected() {
        SimpleAnalytics.trackScreen(EvidaScreens.Error.unexpected)
    }
}
